
export const storeProducts = [
  {
    id: 1,
    title: "Saco de Cimento - 50KG",
    img: "img/produto1.png",
    price: 18.99,
    company: "RR Materiais",
    info:
      "Cimento de alta qualidade que atende as normas e requisitos técnicos das normas ABNT ultilizado para pisos contra-pisos e lajes",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Tijolos - Unidade",
    img: "img/produto2.jpg",
    price: 0.79,
    company: "RR Materiais",
    info:
      "Bloco cerâmico 10x20x30 de Vedação",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Telhas - Unidade",
    img: "img/produto3.jpg",
    price: 1.39,
    company: "RR Materiais",
    info:
      "Telha de cerâmica 41x21 Resinada vermelha",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Caixa D'agua 1500L",
    img: "img/produto4.jpg",
    price: 140.0,
    company: "RR Materiais",
    info:
        "Caixa D'Agua 1500L Polietileno",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "Bloco de Vidro",
    img: "img/produto5.jpg",
    price: 9.54,
    company: "RR Materiais",
    info:
    "Bloco de vidro ondulado incolor 19x19cm",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Piso",
    img: "img/produto6.jpg",
    price: 21.98,
    company: "RR Materiais",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Pia de Banheiro",
    img: "img/produto7.jpg",
    price: 220.4,
    company: "RR Materiais",
    info:
      "Cuba de Louça retangular com Encaixe e Valvula",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Vaso Sanitário",
    img: "img/produto8.jpg",
    price: 170.3,
    company: "RR Materiais",
    info:
     "Vaso sanitário com caixa acoplada 3/6L",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Saco de Cimento 50KG",
  img: "img/produto1.png",
  price: 18.99,
  company: "RR Materiais",
  info:
  "Cimento de alta qualidade que atende as normas e requisitos técnicos das normas ABNT ultilizado para pisos contra-pisos e lajes",
  inCart: false,
  count: 0,
  total: 0
};
